module.exports = __webpack_public_path__ + "img/full-fridge-poet-2.61ef1462.jpg";